// extracted by mini-css-extract-plugin
export default {"root":"legend-pointer_root__OdwE7","arrow":"legend-pointer_arrow__lfoat","placeHolderShimmer":"legend-pointer_placeHolderShimmer__IFL-r"};